import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {env} from "@environments/environment";
import {Observable} from "rxjs";
import {PageModel} from "@app/models/page.model";
import {TextSearchDto} from "@app/ui_models/web-response";
import {map} from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class TextSearchController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/textsearch`;

  public textSearch(params: HttpParams): Observable<PageModel<TextSearchDto>>  {
    return this.httpService.get(this.baseUrl, { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getSuggestions(queryTerm: string, count: number): Observable<string []> {
    let params = new HttpParams();
    params = params.append("query", queryTerm);
    params = params.append("count", count);
    return this.httpService.get(this.baseUrl + "/suggestions", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

}
